import React from "react";
import styles from "./NotFoundBlock.module.scss";
import { useLocation } from "react-router-dom";

export default function NotFoundBlock() {
  let location = useLocation();
  return (
    <div className={styles.root}>
      <h1>
        😕
        <br />
        Error 404
      </h1>
      <p>
        The requested URL <span>{location.pathname}</span> was not fount
      </p>
    </div>
  );
}
